/**
 * Created by yangxuanbin on 05/02/2018
 **/
import React,{Component} from 'react'
import thunk from 'redux-thunk';
import {createStore, applyMiddleware, compose} from 'redux';
import rootReducer from "../reducers/index";

//是否安装了redux调试工具
const redux_dev =  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

// HOC 高阶组件  是否启用调试工具
const composedCreateSotre =
  redux_dev?
    compose(applyMiddleware(thunk),redux_dev)(createStore)
  :
    compose(applyMiddleware(thunk))(createStore);

export default function configureStore(initialState = {}){
  return composedCreateSotre(rootReducer, initialState);
}


// WEBPACK FOOTER //
// ./src/reduxModule/store/configureStore.js